var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "b-form-group",
            {
              staticClass: "col-sm-4",
              attrs: { label: "Record type", "label-for": _vm.id("type") },
            },
            [
              _c("b-form-select", {
                attrs: {
                  id: _vm.id("type"),
                  options: _vm.types.map((value) => ({
                    value,
                    text: _vm.label(value),
                  })),
                },
                on: {
                  change: function ($event) {
                    return _vm.search(1)
                  },
                },
                model: {
                  value: _vm.type,
                  callback: function ($$v) {
                    _vm.type = $$v
                  },
                  expression: "type",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              staticClass: "col-sm-8",
              attrs: { label: "Search by name", "label-for": _vm.id("query") },
            },
            [
              _c(
                "b-input-group",
                [
                  _c("b-form-input", {
                    attrs: { id: _vm.id("query") },
                    on: {
                      keydown: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        $event.preventDefault()
                        return _vm.search(1)
                      },
                    },
                    model: {
                      value: _vm.query,
                      callback: function ($$v) {
                        _vm.query = $$v
                      },
                      expression: "query",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "b-input-group-append",
                    [
                      _c(
                        "b-btn",
                        {
                          attrs: {
                            type: "button",
                            variant: "outline-primary",
                            disabled: _vm.loading,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.search(1)
                            },
                          },
                        },
                        [_vm._v("Search")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.value
        ? _c("p", { staticClass: "small" }, [
            _vm._v("Selected " + _vm._s(_vm.label(_vm.value.type)) + ": "),
            _c("strong", [_vm._v(_vm._s(_vm.entityName(_vm.value)))]),
            _vm._v(" " + _vm._s(_vm.entityAddress(_vm.value))),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? _c("p", { attrs: { role: "status" } }, [_vm._v("Loading records...")])
        : _vm.error
        ? _c(
            "b-alert",
            { attrs: { show: "", variant: "danger" } },
            [
              _vm._v(_vm._s(_vm.error) + " "),
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "link" },
                  on: {
                    click: function ($event) {
                      return _vm.search(_vm.requestedPage)
                    },
                  },
                },
                [_vm._v("Retry")]
              ),
            ],
            1
          )
        : _vm.loaded
        ? [
            _c("p", { staticClass: "small text-muted" }, [
              _vm._v(_vm._s(_vm.meta.total || 0) + " matching records"),
            ]),
            _vm._v(" "),
            !_vm.items.length
              ? _c("p", [_vm._v("No records found.")])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.items, function (item) {
              return _c(
                "div",
                {
                  key: `${item.type}:${item.id}`,
                  staticClass: "border-bottom py-2",
                },
                [
                  _c(
                    "b-form-radio",
                    {
                      attrs: {
                        checked: _vm.value && _vm.value.id,
                        name: _vm.id("target"),
                        value: item.id,
                        disabled:
                          _vm.supplierIdentity && !item.source_record_id,
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$emit("input", item)
                        },
                      },
                    },
                    [
                      _vm._v("\n        " + _vm._s(_vm.entityName(item)) + " "),
                      _c("small", [
                        _vm._v(
                          _vm._s(_vm.label(item.type)) +
                            " · " +
                            _vm._s(_vm.entityAddress(item) || "No address")
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.supplierIdentity && !item.source_record_id
                    ? _c("small", { staticClass: "text-muted" }, [
                        _vm._v("No supplier identity"),
                      ])
                    : _vm._e(),
                ],
                1
              )
            }),
            _vm._v(" "),
            _vm.meta.total > (_vm.meta.per_page || 20)
              ? _c("b-pagination", {
                  staticClass: "mt-2",
                  attrs: {
                    value: _vm.page,
                    "total-rows": _vm.meta.total,
                    "per-page": _vm.meta.per_page || 20,
                  },
                  on: { input: _vm.search },
                })
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }